import { render, staticRenderFns } from "./s-error.vue?vue&type=template&id=17acecd4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17acecd4')) {
      api.createRecord('17acecd4', component.options)
    } else {
      api.reload('17acecd4', component.options)
    }
    module.hot.accept("./s-error.vue?vue&type=template&id=17acecd4&", function () {
      api.rerender('17acecd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-components/s-error/s-error.vue"
export default component.exports